<template>
    <a-col v-if="currentPath === '/provisioning/step1'">
        <h3 class="title_font_Weight">服務同意書</h3>
        <p class="sub_title_width">
            此裝置 (裝置碼)尚未完成開通，請輸入以下資訊完成開通程序：
        </p>
    </a-col>
    <a-col v-else-if="currentPath === '/provisioning/step2'">
        <h3 class="title_font_Weight">輸入開通資料</h3>
        <p class="sub_title_width">
            此裝置 (裝置碼)尚未完成開通，請輸入以下資訊完成開通程序：
        </p>
    </a-col>
    <a-col v-else-if="currentPath === '/provisioning/step3'">
        <h3 class="title_font_Weight">輸入驗證碼</h3>
        <p class="sub_title_width">
            已寄送OTP驗證碼至  {{currentPhone}}
        </p>
    </a-col>
    <a-col v-else-if="currentPath === '/provisioning/step4'">
        <p class="sub_title_width">
            恭喜完成開通程序，下方為您的開通資訊：
        </p>
    </a-col>
    <a-col v-else>
        <p class="sub_title_width individual_title_container">
            下方為您的開通資訊：
        </p>
    </a-col>
</template>

<script>
    export default {
        props: {
        msg: String
        },
        data() {
            return {
                currentPath: '/',
                currentPhone: sessionStorage.getItem('phone'),
            }
        },
        mounted () {
            this.currentPath = this.$route.path;
        },        
        watch: {
            $route: function() {
            console.log('this.$route', this);
            this.currentPath = this.$route.path;
            },
        }        
    }
</script>

<style lang="scss" scoped>
    @import "../../assets/scss/global.scss";

    .individual_title_container {
        padding: 4px 13px 0 13px;
    }
</style>